module.exports = __webpack_public_path__ + "static/media/select_recipe_banner.3c4b51f9.png";